/**
 * @file TopbarMoreMenu.jsx
 * @location src/components/layout/topbar/TopbarMoreMenu.jsx
 * @role 모바일 전용 ⋯ 메뉴 — 다크모드·휴지통·설정 수납(좁은 화면 topbar 정리). CSS 로 ≤768 에서만 노출.
 */
import { useState, useEffect, useRef } from 'react';
import { useApp } from '../../../store/AppContext';
import { isManager } from '../../../utils/permissions';
import { Icon } from '../../ui/Icon';

export function TopbarMoreMenu() {
  const { S, act } = useApp();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const isMgr = isManager((S.members ?? []).find(m => m.id === S.uid));
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  const go = (patch) => { act('SET_UI', { patch }); setOpen(false); };
  const trashN = (S.deletedTasks ?? []).length;

  return (
    <div className="topbar-more" ref={ref}>
      <button className="tnav icon-btn" aria-label="더 보기" onClick={() => setOpen(v => !v)}>
        <Icon name="more" size={16} />
      </button>
      {open && (
        <div className="umenu more-menu">
          <button className="umi" onClick={() => { act('TOGGLE_DARK'); setOpen(false); }}>
            <Icon name={S.darkMode ? 'sun' : 'moon'} size={16} />
            <span style={{ flex: 1, textAlign: 'left' }}>{S.darkMode ? '라이트 모드' : '다크 모드'}</span>
          </button>
          <button className="umi" onClick={() => go({ modalTrash: true })}>
            <Icon name="trash" size={16} />
            <span style={{ flex: 1, textAlign: 'left' }}>휴지통</span>
            {trashN > 0 && <span className="umrole">{trashN}</span>}
          </button>
          <button className="umi" onClick={() => { act('SET_NAV', { nav: 'mypage' }); setOpen(false); }}>
            <Icon name="user" size={16} />
            <span style={{ flex: 1, textAlign: 'left' }}>마이 페이지</span>
          </button>
          {/* 설정 = 워크스페이스 운영 — 매니저 전용. 모달로 열림 */}
          {isMgr && (
            <button className="umi" onClick={() => go({ modalSettings: true })}>
              <Icon name="settings" size={16} />
              <span style={{ flex: 1, textAlign: 'left' }}>설정</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
